const lang = {
  contact: 'Contato',
  experience: 'Experiência Profissional',
  /* You can choose, "Educação" or "Formação Acadêmica"! But the second one is more professional and is more used. */
  education: 'Formação Acadêmica',
  skills: 'Competências',
  about: 'Sobre'
};
export default lang;



// WEBPACK FOOTER //
// ./src/lang/pt-br.js